module.exports = __webpack_public_path__ + "img/banner@2x.000091de.png";